import request from './request';

export const authApi = {
  sendCode: (email: string) => {
    return request.post('/auth/send-code', { email });
  },

  login: (email: string, password: string) => {
    return request.post('/auth/login', { email, password });
  },

  forgotPassword: (email: string, code: string, password: string) => {
    return request.post('/auth/forgot-password', { email, code, password });
  },

  changePassword: (oldPassword: string, newPassword: string) => {
    return request.post('/auth/change-password', { oldPassword, newPassword });
  },

  checkAccess: () => {
    return request.get('/auth/check-access');
  },

  getDisclaimer: () => {
    return request.get('/auth/disclaimer');
  },

  getParameterExplanations: () => {
    return request.get('/auth/parameter-explanations');
  },

  getCurrentUser: () => {
    return request.get('/users/me');
  },

  updateUser: (data: Record<string, never>) => {
    return request.patch('/users/me', data);
  },

  getInvestors: () => {
    return request.get('/users/me/investors');
  },

  selectInvestor: (investorId: number) => {
    return request.post('/users/me/selected-investor', { investorId });
  }
};
